import React from 'react';
import { motion } from 'framer-motion';
import { Dna, Activity, HeartPulse, Droplets, Flame } from 'lucide-react';
const sciencePoints = [{
  icon: Activity,
  title: 'Grelina y Proteína',
  desc: 'La grelina es la hormona del hambre. Sube cuando tu glucosa cae. La única forma de bajarla rápido es con proteína — específicamente leucina (yogur griego, edamame).'
}, {
  icon: Flame,
  title: 'Cortisol y Magnesio',
  desc: 'El cortisol dispara el antojo de azúcar. El magnesio lo neutraliza. El cacao puro y las almendras son las fuentes más biodisponibles de magnesio.'
}, {
  icon: HeartPulse,
  title: 'Dopamina Natural',
  desc: 'Los snacks procesados activan dopamina artificialmente y nunca la saturan. Estas recetas activan dopamina natural, permitiendo que el cerebro llegue a la satisfacción real.'
}, {
  icon: Droplets,
  title: 'Fibra Soluble',
  desc: 'Forma un gel en el intestino que ralentiza la absorción de azúcar y mantiene la glucosa estable hasta 4 horas (avena, garbanzos, chía).'
}, {
  icon: Dna,
  title: 'Grasa Monoinsaturada',
  desc: "Activa la leptina — la hormona que le dice al cerebro 'ya estás satisfecho' — en menos de 15 minutos (aguacate, almendras)."
}];
export function ScienceSection() {
  return <section className="py-24 px-4 bg-brand-dark text-brand-cream relative" data-id="element-249">
      <div className="absolute inset-0 bg-leaf-pattern opacity-30 pointer-events-none" data-id="element-250" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-251">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-252">
          <h2 className="text-4xl md:text-5xl font-bold font-heading text-brand-gold mb-6" data-id="element-253">
            La Ciencia — Por Qué Funciona
          </h2>
          <p className="text-xl text-brand-cream/80 max-w-2xl mx-auto" data-id="element-254">
            No te voy a pedir que confíes en mí. Te voy a mostrar la bioquímica
            detrás de cada receta.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-255">
          {sciencePoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-medium/20 border border-brand-light/20 p-6 rounded-2xl backdrop-blur-sm" data-id="element-256">
              <div className="w-12 h-12 rounded-full bg-brand-gold/20 flex items-center justify-center text-brand-gold mb-4" data-id="element-257">
                <point.icon size={24} data-id="element-258" />
              </div>
              <h3 className="text-xl font-bold text-brand-lightGold mb-3" data-id="element-259">
                {point.title}
              </h3>
              <p className="text-brand-cream/80 text-sm leading-relaxed" data-id="element-260">
                {point.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto" data-id="element-261">
          <p className="text-2xl md:text-3xl font-heading text-brand-gold italic mb-6" data-id="element-262">
            "No es magia. Es bioquímica aplicada a recetas deliciosas."
          </p>
          <p className="text-lg text-brand-cream/70" data-id="element-263">
            Cada ingrediente en cada receta fue elegido por una razón
            específica. No por moda. No por estética. Por química.
          </p>
        </motion.div>
      </div>
    </section>;
}